// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Divider,
    Fab,
    Autocomplete
} from '@mui/material'
import { useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();

    // ** State
    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [valGudang, setValGudang] = useState<any>(null)
    const [listGudang, setListGudang] = useState<any[]>([])

    const [valSubgudang, setValSubgudang] = useState<any>(null)
    const [listSubgudang, setListSubgudang] = useState<any[]>([])

    useEffect(() => {
        getDetail()
        getDoctag()

        getGudang()
        getSubGudang()
    }, [])

    const getDetail = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/purchasing/gr/detail/' + id
        axios
            .get(url, {
                params: { mode: 0 },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]

                    if (data.sysdoctag_id == 12604000012) {
                        setValue('sysdoctag_id', 12604000017)
                    } else if (data.sysdoctag_id == 12604000013) {
                        setValue('sysdoctag_id', 12604000018)
                    } else if (data.sysdoctag_id == 12604000014) {
                        setValue('sysdoctag_id', 12604000019)
                    } else if (data.sysdoctag_id == 12604000015) {
                        setValue('sysdoctag_id', 12604000020)
                    } else if (data.sysdoctag_id == 12604000016) {
                        setValue('sysdoctag_id', 12604000021)
                    }
                    // setValue('sysdoctag_id', data.sysdoctag_id)
                    setValue('tgl', data.tgl?.substring(0, 10))
                    setValue('pbpo_id', data.pbpo_id)
                    setValue('nama_vendor', data.nama_vendor)
                    setValue('nama_vendor', data.nama_vendor)
                    setValue('barang', data.nama_barang)
                    setValue('qty', data.qty)
                    setValue('harga', data.harga)
                    setValue('total', data.total)
                    setValue('sisa_qty', data.sisa_qty)
                    setValue('pbpo_d_id', data.pbpo_d_id)
                    setValue('pbsupplier_id', data.pbsupplier_id)
                    setValue('mmbarang_id', data.mmbarang_id)

                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getDoctag = () => {
        const url = apiUrl.apiUrl + '/system/doctag/list-combo'
        axios
            .get(url, {
                params: {
                    syscabang_id: cabang,
                    sysmenu_id: 40
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach(element => {
                        if (element.id == getValues('sysdoctag_id')) {
                            setValDoctag(element)
                        }
                    });
                    setListDoctag(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getGudang = () => {
        const url = apiUrl.apiUrl + '/mm/gudang/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach(element => {
                        if (element.id == getValues('mmgudang_id')) {
                            setValGudang(element)
                        }
                    });
                    setListGudang(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getSubGudang = () => {
        const url = apiUrl.apiUrl + '/mm/sub-gudang/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach(element => {
                        if (element.id == getValues('mmgudang_sub_id')) {
                            setValSubgudang(element)
                        }
                    });
                    setListSubgudang(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const navigate = useNavigate();

    interface FormInputs {
        syscabang_id: any
        sysdoctag_id: any
        pbsupplier_id: any
        sysmatauang_id: any
        pbpo_id: any
        pbpo_d_id: any
        mmgudang_id: any
        mmgudang_sub_id: any
        barang: any
        qty: any
        tgl: any
        tgl_kirim: any
        transportasi: any
        harga: any
        nomor_timbang: any
        mmbarang_id: any
        nomor_sj: any
        kurir: any
        pic: any
        keterangan: any
        nama_vendor: any
        sisa_qty: any
        total: any
    }

    const defaultValues = {
        syscabang_id: cabang,
        sysmatauang_id: 1,
        sysdoctag_id: 6,
        mmgudang_id: 12509000001,
        mmgudang_sub_id: 12509000001,
    }

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
    }

    const handleChangeAutocompleteGudang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_id', newValue?.id)
        setValGudang(newValue)
    }

    const handleChangeAutocompleteSubgudang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_sub_id', newValue?.id)
        setValSubgudang(newValue)
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const onSubmit = (data: any) => {
        const qty = Number(data.qty)
        const sisaQty = Number(data.sisa_qty)

        if (!Number.isFinite(qty) || qty <= 0) {
            Swal.fire({ title: 'Pemberitahuan', text: 'Quantity harus lebih besar dari 0.', icon: 'warning' })
            return
        }

        if (Number.isFinite(sisaQty) && qty > sisaQty) {
            Swal.fire({
                title: 'Pemberitahuan',
                text: `Quantity tidak boleh melebihi sisa PO (${sisaQty}).`,
                icon: 'warning'
            })
            return
        }

        // Harga dan total hanya untuk preview UI. Backend menghitung ulang dari PO.
        const { harga, total, ...payload } = data

        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                let url = apiUrl.apiUrl + '/purchasing/gr/add'
                axios
                    .post(url, payload, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    const id = response.data.data
                                    navigate('/purchasing/good-receipt/detail/' + id)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Good Receipt
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Divider sx={{ m: 3 }} />
                    {/* <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sysdoctag_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valDoctag}
                                                options={listDoctag}
                                                id='sysdoctag_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteDoctag}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Document Tag'
                                                        error={Boolean(errors.sysdoctag_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.sysdoctag_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Tanggal'
                                                type='date'
                                                error={Boolean(errors.tgl)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.tgl && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    ID PO :
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='pbpo_id'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Typography variant='body1'>
                                                <b>{value}</b>
                                            </Typography>
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Vendor :
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama_vendor'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Typography variant='body1'>
                                                <b>{value}</b>
                                            </Typography>
                                        )}
                                    />
                                    {errors.nama_vendor && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nomor_sj'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Surat Jalan'
                                                error={Boolean(errors.nomor_sj)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nomor_sj && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_kirim'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Tanggal Kirim'
                                                type='date'
                                                error={Boolean(errors.tgl_kirim)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.tgl_kirim && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='transportasi'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Transportasi'
                                                error={Boolean(errors.transportasi)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.transportasi && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kurir'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Kurir'
                                                error={Boolean(errors.kurir)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.kurir && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmgudang_id'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valGudang}
                                                options={listGudang}
                                                id='mmgudang_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteGudang}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Gudang'
                                                        error={Boolean(errors.mmgudang_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmgudang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='mmgudang_sub_id'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valSubgudang}
                                                options={listSubgudang}
                                                id='mmgudang_sub_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteSubgudang}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Sub Gudang'
                                                        error={Boolean(errors.mmgudang_sub_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmgudang_sub_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}></Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Sisa Quantity :
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sisa_qty'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Typography variant='body1'>
                                                <b>{value}</b>
                                            </Typography>
                                        )}
                                    />
                                    {errors.sisa_qty && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='barang'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Barang'
                                                error={Boolean(errors.barang)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ readOnly: true }}
                                            />
                                        )}
                                    />
                                    {errors.barang && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='qty'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Quantity'
                                                error={Boolean(errors.qty)}
                                                onChange={(e) => {
                                                    const data = e.target.value
                                                    const tot = Number(data) * getValues('harga')
                                                    setValue('qty', data)
                                                    setValue('total', tot)
                                                }}
                                                value={value}
                                                type='number'
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.qty && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} hidden>
                                <FormControl fullWidth>
                                    <Controller
                                        name='harga'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Harga'
                                                error={Boolean(errors.harga)}
                                                onChange={onChange}
                                                value={value}
                                                type='number'
                                                inputProps={{ readOnly: true }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.harga && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} hidden>
                                <FormControl fullWidth>
                                    <Controller
                                        name='total'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Total'
                                                error={Boolean(errors.total)}
                                                onChange={onChange}
                                                value={value}
                                                type='number'
                                                inputProps={{ readOnly: true }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.total && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan'
                                                error={Boolean(errors.keterangan)}
                                                onChange={onChange}
                                                multiline
                                                rows={3}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form> */}

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>

                            {/* ================= INFORMASI DOKUMEN ================= */}
                            <Grid item xs={12}>
                                <Card variant="outlined">
                                    <CardContent>
                                        <Typography variant="h6" gutterBottom>
                                            Informasi Dokumen
                                        </Typography>

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <FormControl fullWidth>
                                                    <Controller
                                                        name="sysdoctag_id"
                                                        control={control}
                                                        rules={{ required: true }}
                                                        render={() => (
                                                            <Autocomplete
                                                                value={valDoctag}
                                                                options={listDoctag}
                                                                id="sysdoctag_id"
                                                                isOptionEqualToValue={(o: any, v: any) => o.id === v.id}
                                                                onChange={handleChangeAutocompleteDoctag}
                                                                getOptionLabel={(o: any) => o.nama}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Document Tag"
                                                                        error={Boolean(errors.sysdoctag_id)}
                                                                    />
                                                                )}
                                                            />
                                                        )}
                                                    />
                                                    {errors.sysdoctag_id && (
                                                        <FormHelperText error>Form ini tidak boleh kosong</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <FormControl fullWidth>
                                                    <Controller
                                                        name="tgl"
                                                        control={control}
                                                        rules={{ required: true }}
                                                        render={({ field }) => (
                                                            <TextField
                                                                {...field}
                                                                label="Tanggal"
                                                                type="date"
                                                                InputLabelProps={{ shrink: true }}
                                                                error={Boolean(errors.tgl)}
                                                            />
                                                        )}
                                                    />
                                                    {errors.tgl && <FormHelperText error>Form ini tidak boleh kosong</FormHelperText>}
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography variant="caption" color="text.secondary">
                                                    ID PO
                                                </Typography>
                                                <Typography fontWeight={600}>
                                                    {getValues('pbpo_id')}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Typography variant="caption" color="text.secondary">
                                                    Vendor
                                                </Typography>
                                                <Typography fontWeight={600}>
                                                    {getValues('nama_vendor')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>

                            {/* ================= BARANG ================= */}
                            <Grid item xs={12}>
                                <Card sx={{ backgroundColor: '#fafafa' }}>
                                    <CardContent>
                                        <Typography variant="h6" gutterBottom>
                                            Detail Barang
                                        </Typography>

                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item xs={12} md={6}>
                                                <Controller
                                                    name="barang"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField {...field} label="Barang" fullWidth InputProps={{ readOnly: true }}
                                                            InputLabelProps={{ shrink: true }} />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={3}>
                                                <Typography variant="caption" color="text.secondary">
                                                    Sisa Quantity
                                                </Typography>
                                                <Typography variant="h6" color="primary">
                                                    {getValues('sisa_qty')}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} md={3}>
                                                <Controller
                                                    name="qty"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            {...field}
                                                            label="Quantity"
                                                            type="number"
                                                            fullWidth
                                                            InputLabelProps={{ shrink: true }}
                                                            onChange={(e) => {
                                                                const data = e.target.value
                                                                const tot = Number(data) * getValues('harga')
                                                                setValue('qty', data)
                                                                setValue('total', tot)
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>

                            {/* ================= PENGIRIMAN ================= */}
                            <Grid item xs={12}>
                                <Card variant="outlined">
                                    <CardContent>
                                        <Typography variant="h6" gutterBottom>
                                            Informasi Pengiriman
                                        </Typography>

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <Controller
                                                    name="nomor_sj"
                                                    control={control}
                                                    rules={{ required: false }}
                                                    render={({ field }) => (
                                                        <TextField {...field} label="Surat Jalan" fullWidth error={!!errors.nomor_sj} />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Controller
                                                    name="tgl_kirim"
                                                    control={control}
                                                    rules={{ required: false }}
                                                    render={({ field }) => (
                                                        <TextField {...field} label="Tanggal Kirim" type="date" fullWidth InputLabelProps={{ shrink: true }} error={!!errors.tgl_kirim} />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Controller
                                                    name="transportasi"
                                                    control={control}
                                                    rules={{ required: false }}
                                                    render={({ field }) => (
                                                        <TextField {...field} label="Transportasi" fullWidth error={!!errors.transportasi} />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Controller
                                                    name="kurir"
                                                    control={control}
                                                    rules={{ required: false }}
                                                    render={({ field }) => (
                                                        <TextField {...field} label="Kurir" fullWidth error={!!errors.kurir} />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>

                            {/* ================= GUDANG ================= */}
                            <Grid item xs={12}>
                                <Card variant="outlined">
                                    <CardContent>
                                        <Typography variant="h6" gutterBottom>
                                            Lokasi Gudang
                                        </Typography>

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6}>
                                                <Autocomplete
                                                    value={valGudang}
                                                    options={listGudang}
                                                    isOptionEqualToValue={(o: any, v: any) => o.id === v.id}
                                                    onChange={handleChangeAutocompleteGudang}
                                                    getOptionLabel={(o: any) => o.nama}
                                                    renderInput={(params) => <TextField {...params} label="Gudang" />}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                                <Autocomplete
                                                    value={valSubgudang}
                                                    options={listSubgudang}
                                                    isOptionEqualToValue={(o: any, v: any) => o.id === v.id}
                                                    onChange={handleChangeAutocompleteSubgudang}
                                                    getOptionLabel={(o: any) => o.nama}
                                                    renderInput={(params) => <TextField {...params} label="Sub Gudang" />}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>

                            {/* ================= KETERANGAN ================= */}
                            <Grid item xs={12}>
                                <Controller
                                    name="keterangan"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField {...field} label="Keterangan" multiline rows={3} fullWidth />
                                    )}
                                />
                            </Grid>

                            {/* ================= ACTION ================= */}
                            <Grid item xs={12}>
                                <Box display="flex" justifyContent="center" mt={4}>
                                    <Button variant="contained" type="submit">
                                        SIMPAN
                                    </Button>
                                </Box>
                            </Grid>

                        </Grid>
                    </form>

                </div>
            </Grid>
        </Grid>
    )
}